<template>
  <a-modal :visible="showDialog" :mask="false" title="数据误差上报" @ok="handleOk" @cancel="handleCancel()">
   <a-form layout="inline">
     <a-form-item label="当前渠道">
       {{baseInfo.channel}}
     </a-form-item>
     <a-form-item label="数据类型">
       {{data_type_list[baseInfo.type]}}
     </a-form-item>
     <a-form-item label="数据区间">
       {{baseInfo.start}} - {{baseInfo.end}}
     </a-form-item>
   </a-form>
    <a-form layout="inline">
      <a-form-item label="当前值">
        <a-input-number v-model="baseInfo.now_num" disabled></a-input-number>
      </a-form-item>
      <a-form-item label="真实值">
        <a-input-number v-model="change_num"></a-input-number>
      </a-form-item>
      <a-form-item label="准确率" v-if="change_num">
        <span style="color: red">{{Math.round(baseInfo.now_num*10000/change_num)/100}}%</span>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import {AddErrorData} from "../../../api/v1/base_info";

export default {
  name: "DataErrorDialog",
  props:['showDialog','baseInfo', 'cate'],
  data(){
    return {
      change_num:0,
      data_type_list:{
        'spend':'消耗',
        'revenue':'收益',
        'purchase':'内购'
      }
    }
  },
  watch:{
    showDialog:{
      handler:function (_new,_old) {
        this.change_num = ''
      }
    }
  },
  methods:{
    handleOk(){
      this.baseInfo.change_num = this.change_num
      AddErrorData({...this.baseInfo, cate: this.cate}).then(resp => {
        if (resp.code===200){
          this.$message.success(resp.msg)
          this.$emit('close-dialog')
        }else{
          this.$message.error(resp.msg)
        }
      })
    },
    handleCancel(){
      this.$emit('close-dialog')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Business/Dialog/DataErrorDialog.vue